import { z } from 'zod';

import { PHONE_REGEX, personNameField } from './fields';

export const SUBJECTS = [
  'Question générale',
  'Support technique',
  'Inscription à un concours',
  'Gestion de mon club',
  'Problème de paiement',
  'Données personnelles',
  'Demande de retrait de fiche club',
  'Autre',
] as const;

export const contactSchema = z.object({
  fullName: personNameField('Nom', 120),
  email: z.string().trim().email('Email invalide').max(254, 'Email trop long'),
  phone: z
    .string()
    .trim()
    .optional()
    .or(z.literal(''))
    .refine(v => !v || PHONE_REGEX.test(v), 'Numéro de téléphone invalide'),
  subject: z.enum(SUBJECTS, { message: 'Sujet requis' }),
  message: z.string().trim().min(10, 'Message trop court (min 10 caractères)').max(5000),
  captchaToken: z.string().trim().min(1, 'CAPTCHA requis'),
});

export type ContactFormValues = z.infer<typeof contactSchema>;
